import gql from 'graphql-tag';

export default gql`
    mutation SaveLofa($input: SaveLofaInput) {
        saveLofa(input: $input) {
            errors
        }
    }
`;
